import handleFormatPrice from "./handleFormatPrice";

function getConsumptionOffsetDisplay(offset, is_synthetic) {
    if (is_synthetic === 0) return handleFormatPrice(offset, 2, " %");
    else return "-/-";
}

export default getConsumptionOffsetDisplay;